import { render } from "./CreateContact.vue?vue&type=template&id=0f26be36"
import script from "./CreateContact.vue?vue&type=script&lang=js"
export * from "./CreateContact.vue?vue&type=script&lang=js"
script.render = render

export default script